import React, { useEffect } from 'react';
// @ts-ignore
import { useLocation } from 'react-router-dom';
import Online from '../../../assets/images/online.png';
import Telefone from '../../../assets/images/telefone_sip.jpg';
import Softphone from '../../../assets/images/Softphone.jpg';
import AdaptadorATA from '../../../assets/images/ata.jpg';
import GatewaySIP from '../../../assets/images/gateway_sip.jpg';
import Headset from '../../../assets/images/Headset.jpg';
import Sip1 from '../../../assets/images/sip1.jpg';
import Sip2 from '../../../assets/images/sip2.jpg';
import ListGroup from 'react-bootstrap/ListGroup';

import './styles.css';

const Orientacao = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [location.pathname]);

  return (
    <div className="container">
      <div className="row">
        <div className='orientacao'>
          <h4>Desvendando a Tecnologia da Telefonia Fixa: Orientações para uma compreensão de como funciona.</h4>
          <br />
        </div>

        <div className="col-sm-12 col-md-5">

          <div className="info">
            <img src={Online} alt="Foto" />
          </div>
        </div>
        <div className="col-sm-12 col-md-7">
          <p>
            A telefonia pela internet usando a tecnologia SIP (Session Initiation Protocol) é uma forma
            de comunicação de voz que utiliza a internet para realizar chamadas telefônicas. O SIP é um
            protocolo de sinalização amplamente utilizado em serviços de Voz sobre IP (VoIP) e permite
            que as chamadas sejam estabelecidas,
            gerenciadas e finalizadas por meio de pacotes de dados transmitidos pela internet.
          </p>
          <h5>Principais características da telefonia SIP:</h5>
          <ListGroup>
            <ListGroup.Item>
              Conexão pela internet: As chamadas telefônicas são realizadas por meio de uma conexão à internet,
              permitindo que os usuários façam e recebam ligações de qualquer lugar do mundo com acesso à internet.
            </ListGroup.Item>
            <ListGroup.Item>
              Flexibilidade: O SIP é um protocolo aberto e padronizado, o que significa que pode ser utilizado por
              uma variedade de dispositivos e aplicativos de comunicação, proporcionando maior flexibilidade para
              as empresas e usuários.
            </ListGroup.Item>
            <ListGroup.Item>
              Redução de custos: A telefonia SIP é uma opção mais econômica em comparação com as linhas telefônicas
              tradicionais, pois utiliza a infraestrutura da internet para transmitir as chamadas, reduzindo os gastos com tarifas e taxas.
            </ListGroup.Item>
            <ListGroup.Item>
              Integração com outros serviços: A tecnologia SIP pode ser facilmente integrada a outros serviços de comunicação, como
              videoconferências e mensagens instantâneas, proporcionando uma experiência de comunicação mais completa.
            </ListGroup.Item>
            <ListGroup.Item>
              Escalabilidade: A telefonia SIP é escalável e pode ser facilmente expandida para atender às necessidades crescentes de uma
              empresa ou organização, sem a necessidade de grandes investimentos em infraestrutura.
            </ListGroup.Item>
            <ListGroup.Item>
              Recursos avançados: A tecnologia SIP oferece uma variedade de recursos avançados, como encaminhamento de chamadas, conferências telefônicas, correio
              de voz e identificador de chamadas, proporcionando maior produtividade e eficiência nas comunicações.
            </ListGroup.Item>
          </ListGroup>
        </div>
      </div>
      <hr />
      <div className='row'>
        <div className='orientacao'>
          <h4>Para utilizar a telefonia SIP, você precisará de alguns dispositivos essenciais:</h4>
          <span>Lembre-se que não será necessario utilizar todos os aparelhos listado, cada cenário poderá ter uma configuração diferente. </span>
          <br />
        </div>

        <div className="col-sm-12">
          <ListGroup>
            <ListGroup.Item>
              <div className='list'>
                <img src={Telefone} alt='foto' />
                <p>
                  Telefone SIP: É o aparelho específico para fazer e receber chamadas pela tecnologia SIP. Existem
                  diferentes modelos de telefones SIP, desde os tradicionais com fio até os modernos telefones IP
                  sem fio.
                </p>
              </div>
            </ListGroup.Item>
            <ListGroup.Item>
              <div className='list'>
                <img src={Softphone} alt='foto' />
                <p>
                  Softphone: Trata-se de um aplicativo de telefone que você pode instalar em um computador, tablet
                  ou smartphone.
                  Ele simula as funções de um telefone tradicional e permite realizar chamadas através da internet.
                </p>
              </div>
            </ListGroup.Item>
            <ListGroup.Item>
              <div className='list'>
                <img src={AdaptadorATA} alt='foto' />
                <p>
                  Adaptador ATA: Se você possui um telefone analógico convencional e deseja usá-lo na telefonia SIP,
                  precisará de um Adaptador ATA (Adaptador de Telefone Analógico). Ele conecta o
                  telefone analógico à sua rede de internet e faz a conversão dos sinais analógicos para digitais.
                </p>
              </div>
            </ListGroup.Item>
            <ListGroup.Item>
              <div className='list'>
                <img src={GatewaySIP} alt='foto' />
                <p>
                  Gateway SIP: Caso você já possua uma central telefônica tradicional (PABX) e queira integrá-la à
                  telefonia SIP, pode ser necessário um Gateway SIP. Ele faz a interface entre a central telefônica
                  e a rede IP, permitindo que as chamadas sejam realizadas através da tecnologia SIP.
                </p>
              </div>
            </ListGroup.Item>
            <ListGroup.Item>
              <div className='list'>
                <img src={Headset} alt='foto' />
                <p>
                  Headset: Se estiver usando um softphone em um computador ou dispositivo móvel, um headset pode
                  ser útil para realizar chamadas de forma mais confortável e com maior qualidade de áudio.
                </p>
              </div>
            </ListGroup.Item>
          </ListGroup>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 col-md-6'>
          <div className='diagrama'>
            <img src={Sip1} alt='foto' />
            
          </div>
        </div>
        <div className='col-sm-12 col-md-6'>
          <div className='diagrama'>
            <img src={Sip2} alt='foto' />
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orientacao;
